var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 1h-18c-1.654 0-3 1.346-3 3v16c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3v-16c0-1.654-1.346-3-3-3z",
    fill: "#607d8b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21 21h-18c-.551 0-1-.448-1-1v-14h20v14c0 .552-.449 1-1 1z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 1h-9c-1.654 0-3 1.346-3 3v16c0 1.654 1.346 3 3 3h9v-2h-9c-.551 0-1-.448-1-1v-14h10z",
    fill: "#546d79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 6h-10v14c0 .552.449 1 1 1h9z",
    fill: "#dedede"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.431 20h-3.862c-.865 0-1.569-.704-1.569-1.569v-8.862c0-.865.704-1.569 1.569-1.569h3.861c.866 0 1.57.704 1.57 1.569v8.862c0 .865-.704 1.569-1.569 1.569z",
    fill: "#90caf9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10.85 14.68-.88-1.17c-.22-.3-.57-.49-.95-.51-.37-.02-.74.14-.99.42l-1.261 1.4-.35-.43c-.23-.26-.56-.42-.91-.44-.35-.01-.68.12-.93.37l-.579.58v3.53c0 .87.7 1.57 1.57 1.57h3.86c.87 0 1.57-.7 1.57-1.57v-3.3c0-.16-.05-.32-.15-.45z",
    fill: "#8bc34a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m5.44 19.995c.042.003.086.005.129.005h1.931-1.93c-.044 0-.087-.002-.13-.005zm2.06-11.995h-1.931c-.865 0-1.569.704-1.569 1.569v8.862c0 .045.002.089.006.133-.004-.044-.006-.089-.006-.134v-3.53l.58-.58c.241-.241.556-.37.891-.37.013 0 .026 0 .038.001.351.02.681.18.91.44l.35.43.73-.811v-6.01z",
    fill: "#7db0d9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m5.471 13.95c-.335 0-.65.129-.891.37l-.58.58v3.53c0 .045.002.09.006.134.064.763.669 1.367 1.433 1.43h.001c.043.004.086.006.13.006h1.93v-5.991l-.73.811-.35-.43c-.23-.26-.56-.42-.91-.44-.013 0-.026 0-.039 0z",
    fill: "#79aa40"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m18.431 20h-3.861c-.866 0-1.57-.704-1.57-1.569v-8.862c0-.865.704-1.569 1.569-1.569h3.861c.866 0 1.57.704 1.57 1.569v8.862c0 .865-.704 1.569-1.569 1.569z",
    fill: "#90caf9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m19.97 13.51c-.22-.3-.569-.49-.95-.51-.369-.02-.739.14-.989.42l-1.261 1.4-.35-.43c-.229-.26-.56-.42-.91-.44-.34-.01-.68.12-.93.37l-1.36 1.36c-.14.14-.22.33-.22.53v2.22c0 .87.7 1.57 1.57 1.57h3.859c.871 0 1.571-.7 1.571-1.57v-4.88z",
    fill: "#8bc34a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m14.44 19.995c.043.003.086.005.129.005h1.931-1.93c-.044 0-.087-.002-.13-.005zm2.06-11.995h-1.931c-.865 0-1.569.704-1.569 1.569v8.862c0 .045.002.089.006.133-.004-.044-.006-.089-.006-.134v-2.22c0-.2.08-.39.22-.53l1.36-1.36c.241-.241.565-.37.892-.37.012 0 .025 0 .037.001.351.02.681.18.91.44l.08.098v-6.489z",
    fill: "#7db0d9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m15.472 13.95c-.327 0-.651.129-.892.37l-1.36 1.36c-.14.14-.22.33-.22.53v2.22c0 .045.002.09.006.134.064.763.669 1.368 1.433 1.43h.001c.043.004.086.006.13.006h1.93v-5.511l-.08-.098c-.229-.26-.56-.42-.91-.44-.013-.001-.025-.001-.038-.001z",
    fill: "#79aa40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.76bf117de813b9274f54b6f9f18c2796.svg";
export { ForwardRef as ReactComponent };